import Text from 'src/components/text';
import { Document } from 'src/types/document';
import Skeleton from 'src/components/skeleton';
import Card from 'src/components/card';
import CardRow from 'src/components/cardRow';
import ProductScore from 'src/pages/battery-cells/components/productScore';
import CellProducerScore from 'src/pages/battery-cells/components/cellProducerScore';
import ChemistryScore from 'src/pages/battery-cells//components/chemistryScore';

type Props = {
  product?: Document;
};

const Scoring = ({ product }: Props) => {
  if (!product) {
    return <Skeleton height="367px" />;
  }

  return (
    <div>
      <Text variant="h5" dense>
        Scoring
      </Text>
      <Card>
        <CardRow center>
          <ProductScore product={product} />
          <CellProducerScore product={product} />
          <ChemistryScore product={product} />
        </CardRow>
      </Card>
    </div>
  );
};

export default Scoring;
